/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable object-curly-newline */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';

import Form from '../../../common/Form';
import { form as FormStyle } from '../../../style/form';
import { deepObjectExtend } from '../../../utils/object';
import { combineStyle } from '../../../style/combineStyle';
import { DesktopTrackOrderStyle } from '../../../style/DesktopTrackOrderStyle';
import configENV from '../../../config';
import DesktopOrderByZipCode from './DesktopOrderByZipCode';
import DesktopDeliveryHours from './DesktopDeliveryHours';
import DesktopSignInOrder from  './DesktopSignInOrder';
import GraphqlSeoHeadTags from '../../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const { AUTH_LOGIN_URL, PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        FormStyle,
        DesktopTrackOrderStyle,
    }),
);

class DesktopTrackOrder extends Form {
    handleSignInClicked = () => {
        this.props.history.push(AUTH_LOGIN_URL);
    };

    render() {
        /* eslint-disable max-len */
        const { isReadyState, classes, featureFlags } = this.props;
        const seo = {
            page_title: 'Order Tracking to Track Your 1800Flowers Order | 1800Flowers',
            meta_description: 'Easily track your 1800Flowers order by signing in to your account, or by inputting your order number. Delivery hours based on recipient\'s time zone: Residential: 9am-8pm & Business: 9am-6pm.',
            location: { pathname: '/account/orders' },
        };
        return (
            <>
                <GraphqlSeoHeadTags seoData={seo} />
                <h1 className={classes.trackOrderHeader}><span>Track Your Order</span></h1>
                <div className={classes.DesktopTrackOrderStyle}>
                    <DesktopDeliveryHours classes={classes} />
                    <DesktopSignInOrder props={this.props} />
                    <div className="OR-dividerWrapper">
                        <div className="OR-divider">or</div>
                    </div>
                    <DesktopOrderByZipCode isReadyState={isReadyState} featureFlags={featureFlags} />
                </div>
            </>
        );
    }
}

DesktopTrackOrder.defaultProps = {
    handleSubmitOrderByZipCode: () => {},
    router: {},
};

DesktopTrackOrder.propTypes = {
    isReadyState: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    router: PropTypes.object,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        error: newState.error,
        featureFlags: getFeatureFlags(state),
    };
};

export default connect(
    mapStateToProps,
)(withRouter(withStyles(styles)(DesktopTrackOrder)));
